import { useState } from "react";
import { isMobile } from "../../../services/clientService";
import "./index.scss";
import { IoMdMenu } from '@react-icons/all-files/io/IoMdMenu'
import { Drawer } from "antd";
import Sidebar from "../../../pages/OnboardingModal/Components/Sidebar";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Header =  props => {
    const location = useLocation()
    const isHidden = location.pathname.includes('/auth')
    
    const [open, setOpen] = useState(false)
    if (isHidden) return null
    if (!isMobile()) return null;
    if (location.pathname.includes('resume-builder')) return null;
    return (
        <header className="header">
            <div className="inner">
                <div className="logo">
                    <img src="/logos/logo-genie-blue.png" alt="Get In Genie Logo" />
                </div>
                {!window.location.pathname.includes('auth') &&<div className="menu-btn" onClick={() => setOpen(true)}>
                    Menu
                    <IoMdMenu />
                </div>}
            </div>
            <Drawer placement="left" open={open} onClose={() => setOpen(false)} >
                 <Sidebar onExit={() => setOpen(false)} />
            </Drawer>
        </header>
    )
}
export default Header;